import React from 'react';
import './browser.warning.css';
import { detect } from 'detect-browser';
export default function BrowserWarning() {

    const unsupportedBrowsers = ['ie'];
    const browserName = detect()?.name || '';

    return (
        unsupportedBrowsers.includes(browserName) ? (
            <div className="browser-warning-container">
                <div>It looks like you are using Internet Explorer, an outdated browser. This site will not work properly if you continue. Please upgrade to Microsoft Edge or use other modern browsers such as Google Chrome &amp; Mozilla Firefox.</div>
                <div className="browsers-container">
                    <div className="browser">
                        <a href="https://www.microsoft.com/en-us/edge">
                            <img src="images/edge.png" />
                        </a>
                    </div>
                    <div className="browser">
                        <a href="https://www.google.com/chrome/">
                            <img src="images/chrome.png" />
                        </a>
                    </div>
                    <div className="browser">
                        <a href="https://www.mozilla.org/en-CA/firefox/new/">
                            <img src="images/firefox.png" />
                        </a>
                    </div>
                </div>
            </div>
        ) : (
            <></>
        )
    );
}